var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullday(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "23px",
    viewBox: "0 0 15 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.239326374 14.8109637 0.239326374 14.8109637 22.7472275 0 22.7472275"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 22.7607747 14.810989 22.7607747 14.810989 0.252620879 0 0.252620879"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NEW-COD-POD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Closure-4-History",
    transform: "translate(-391.000000, -197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(391.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.013522)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30348022,11.5047769 C8.30348022,12.3679088 8.7933044,13.2075352 9.67968901,13.8141286 L10.1227549,14.0939198 C12.3153374,15.1433264 13.6680407,17.312656 13.6680407,19.7382714 L13.6680407,20.3216121 L1.11964505,20.3216121 L1.11964505,19.7382714 C1.11964505,17.312656 2.47234835,15.1433264 4.66493077,14.0939198 L5.1079967,13.8141286 C5.99438132,13.2075352 6.48420549,12.3679088 6.48420549,11.5047769 C6.48420549,10.6418978 5.99438132,9.80227143 5.1079967,9.19567802 L4.66493077,8.91588681 C2.47234835,7.86622747 1.11964505,5.69715055 1.11964505,3.27128242 L1.11964505,2.68819451 L13.6680407,2.68819451 L13.6680407,3.27128242 C13.6680407,5.69715055 12.3153374,7.86622747 10.1227549,8.91588681 L9.67968901,9.19567802 C8.81655714,9.80227143 8.30348022,10.6418978 8.30348022,11.5047769 M10.4960626,9.6389967 C12.851667,8.47282088 14.4844143,6.07045824 14.4844143,3.24802967 L14.4844143,1.91857912 C14.647689,1.84856813 14.8109637,1.70854615 14.8109637,1.3819967 L14.8109637,0.822414286 C14.8109637,0.822414286 14.8109637,0.239326374 14.2278758,0.239326374 L0.583062637,0.239326374 C0.583062637,0.239326374 -2.52747253e-05,0.239326374 -2.52747253e-05,0.822414286 L-2.52747253e-05,1.3819967 C-2.52747253e-05,1.3819967 -2.52747253e-05,1.77855714 0.326524176,1.91857912 L0.326524176,3.24802967 C0.326524176,6.04695275 1.95927143,8.47282088 4.31512857,9.61549121 C5.15475495,10.0820626 5.69108462,10.7351615 5.69108462,11.4815242 C5.69108462,12.2046341 5.15475495,12.8809857 4.31512857,13.3475571 C1.95927143,14.4904802 0.326524176,16.9160956 0.326524176,19.7150187 L0.326524176,21.0679747 C0.163249451,21.137733 -2.52747253e-05,21.2777549 -2.52747253e-05,21.6043044 L-2.52747253e-05,22.1641396 C-2.52747253e-05,22.1641396 -2.52747253e-05,22.7472275 0.583062637,22.7472275 L14.2278758,22.7472275 C14.2278758,22.7472275 14.8109637,22.7472275 14.8109637,22.1641396 L14.8109637,21.6043044 C14.8109637,21.6043044 14.8109637,21.2079967 14.4844143,21.0679747 L14.4844143,19.7382714 C14.4844143,16.9396011 12.851667,14.513733 10.4960626,13.3708099 C9.65643626,12.9042385 9.11985385,12.2511396 9.11985385,11.5047769 C9.11985385,10.7819198 9.65643626,10.1055681 10.4960626,9.6389967",
    id: "Fill-1",
    fill: "#F3E005",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#F3E005",
    points: "7.41345604 18.1255165 1.95815934 20.0436154 12.8690055 20.0436154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63703846,6.64725275 C2.63703846,6.64725275 3.73219231,8.07957143 7.39374176,10.1435055 C7.39374176,10.1435055 11.7359396,7.91098901 12.1150604,6.64725275 L2.63703846,6.64725275 Z",
    id: "Fill-6",
    fill: "#F3E005"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#F3E005",
    mask: "url(#mask-4)",
    points: "7.14112088 18.6104121 7.64661538 18.6104121 7.64661538 9.1745989 7.14112088 9.1745989"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullday);
export default __webpack_public_path__ + "static/media/fullday.9af7f46e573669035f90640e2de50b9e.svg";
export { ForwardRef as ReactComponent };